export default __webpack_public_path__ + "static/media/reloj.df1f7f1e.svg";